<template>
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" data-comp="i-play">
    <path fill="currentColor" d="M8 5v14l11-7z" />
  </svg>
</template>

<script>
export default {
  name: "IconPlay",
};
</script>
